import React, { useContext, useMemo, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { InfluencerContext } from '../../../../../contexts/InfluencerContext'
import { SharedCampaignContext } from '../../../../../contexts/Advertiser/SharedCampaignContext'
import Authentication from '../../../../../models/Authentication'
import getUnicodeFlagIcon from 'country-flag-icons/unicode'
import { formatNumber } from '../../../../../utils/Helper'
import { observer } from 'mobx-react-lite'
import { PeopleFill, Cursor } from 'react-bootstrap-icons'
import axiosService from '../../../../../utils/AxiosService'
import { toastError } from '../../../../../components/FormComponents/Toasts'

export default observer(function SimilarCreators() {
  const params = useParams()
  const { id, authentication_id, campaign_authentication_id } = params
  const navigate = useNavigate()
  const influencerContext = useContext(InfluencerContext)
  const sharedCampaignContext = useContext(SharedCampaignContext)
  const [authentications, setAuthentications] = useState([])

  const isAdvertiserContext = !!sharedCampaignContext?.campaignState
  const currentId = isAdvertiserContext ? authentication_id : id

  useEffect(() => {
    if (isAdvertiserContext && authentication_id) {
      axiosService.get(`/api/advertiser/campaign_share/authentications/${authentication_id}/authentications`)
        .then(authentications => {
          const mappedAuthentications = authentications.map(authentication => new Authentication(authentication))
          setAuthentications(mappedAuthentications)
        })
        .catch((error) => {
          const errorMessage = error?.response?.data?.error || error?.data?.error || error?.error || error?.message || 'An error occurred'
          toastError(errorMessage)
        })
    }
  }, [isAdvertiserContext, authentication_id])

  const pmAuthentications = influencerContext?.authentications || []
  const currentAuthentications = isAdvertiserContext ? authentications : pmAuthentications

  const currentAuthentication = useMemo(() => currentAuthentications.find(authentication => +authentication.id === +currentId ) || new Authentication(), [currentId, currentAuthentications, currentAuthentications.length] )
  const similarAuthentications = useMemo(() => currentAuthentication.similar_authentications?.slice(0, 8) || [], [currentAuthentication, currentAuthentication.similar_authentications, currentAuthentication.similar_authentications?.length])

  return (
    <div className="w-full bg-white dark:bg-rb-dark-mode p-4 rounded-md">
      <div className="flex justify-between">
        <p className="font-bold text-xl mb-4 dark:text-white">Similar Creators</p>
        {!isAdvertiserContext && <button className="font-bold text-sm dark:text-white" onClick={() => navigate(`/project_manager/authentications/${currentAuthentication.id}/influencer/similar_influencers`)}>Go to similar influencers</button>}
      </div>
      <div className="flex gap-4 overflow-x-auto pb-2 flex-nowrap">
        {similarAuthentications.map(authentication => {
          const avatarUrl = typeof authentication.avatar === 'string' ? authentication.avatar : authentication.avatar?.url
          return (
          <div key={authentication.id} className="rounded-lg bg-white dark:bg-rb-dark-mode p-4 flex w-96 border border-gray-200 dark:border-rb-dark-mode-lighter flex-shrink-0">
            <img src={avatarUrl} alt={avatarUrl} className="w-18 h-18 rounded-lg" />
            <div className="flex flex-col justify-between ml-4 w-full">
              <div className="flex justify-between">
                <p className="text-sm font-bold dark:text-white">{authentication.username}</p>
                <p className="">{authentication.country && getUnicodeFlagIcon(authentication.country)}</p>
              </div>
              <div className="flex justify-between">
                <p className="text-sm mr-4 flex items-center gap-2 dark:text-white"><PeopleFill className="text-gray-500 dark:text-white" /><span className="dark:text-white">Follower <span className="font-bold dark:text-white">{formatNumber(authentication.reach)}</span></span></p>
                <p className="text-sm flex items-center gap-2 dark:text-white"><Cursor className="text-gray-500 dark:text-white" /><span className="dark:text-white">Eng. rate <span className="font-bold dark:text-white">{(authentication.engagement_rate * 100).toFixed(2)}%</span></span></p>
              </div>
            </div>
          </div>
          )
        })}
      </div>
    </div>
  )
})